<template>
  <div class="container">
    <w-navbar
        v-show="iosOrAndroidShow"
        :icon="'iconchevron-left'"
        :cvShow="true"
        @mobileLeftBtn="leftBtnClick"
    />
    <w-loading v-if="isLoading"></w-loading>
    <template v-else>
      <template v-if="list.length>0 && !isHarmony">
        <div>
          <div class="success-image">
            <img src="https://files.wondercv.com//mobile/cvs/success-icon.png">
            <p >发送成功</p>
          </div>
          <div class="matching">
            以下职位和您的简历匹配度95%
          </div>
          <div class="post-list">
            <job-list :listData="list"></job-list>
          </div>
        </div>
        <div class="btn-bg">
          <div class="btn" @click="handleClickMorePost">
            查看更多职位
          </div>
        </div>

      </template>
      <template v-else>
        <div class="empty-post">
          <img src="https://files.wondercv.com//mobile/cvs/success-icon.png">
          <p class="success-text">发送成功</p>
          <template v-if="!isHarmony">
            <p class="matching-text">当前有职位和你的简历匹配度很高，快来看看吧</p>
            <div class="empty-btn" @click="handleClickMorePost">去看职位</div>
          </template>
        </div>
      </template>
    </template>

  </div>
</template>

<script>
  import WNavbar from "@/components/global/w-navbar";
  import jobList from "../job-components/job-list"
  import { userMixin } from '@/assets/js/mixin/user'
  import { envMixin } from '../../assets/js/mixin/global'
  import WLoading from "@/components/global/w-loading"

  export default {
    name: "sessuce",
    mixins: [userMixin, envMixin],
    data() {
      return {
        iosOrAndroidShow: true,
        list: [],
        isLoading: false
      }
    },
    components: {WNavbar, jobList, WLoading},
    methods: {
      leftBtnClick() {
        this.$router.go(-1)
      },
      //获取推荐岗位
      async getPostList() {
        try {
          this.isLoading = true
          let params = {
            size: 6,
            page: 1,
            // jd_flag: 1,
            resume_token: this.$route.query.token,
            // resume_flag: 1
            cv_account_token: this.cvAccountToken
          }
          // let res = await this.$api.HrApi.getJobByCv(params)
          let res = await this.$api.recommend.editorToJob(params)
          this.list = res.data.jobs
        } finally {
          this.isLoading = false
        }
      },
      //跳转更多
      handleClickMorePost(){
        this.$router.replace('/jobs/recommend')
      }
    },
    created() {
      this.getPostList()
    }
  }
</script>

<style lang="scss" scoped>
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";

  .container {
    padding-top: 44px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .success-image {
      width: 100%;
      height: 65px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      font-weight: 500;
      color: rgba(64, 64, 64, 1);
      position: relative;

      > img {
        width: 30px;
        height: 25px;
        margin-right: 4px;
      }
    }

    .matching {
      width: 375px;
      height: 38px;
      background: rgba(255, 102, 68, 0.05);
      padding: 12px 0 12px 24px;
      color: #FF6644;
      font-size: 14px;
      font-weight: 400;
    }

    .post-list {
      position: relative;
      padding: 0 24px;
      margin-bottom: 78px;
      /deep/ .recommend-item {
        border-bottom: 1px solid #F9F9F9;
      }
    }
    .btn-bg{
      position: fixed;
      bottom: 0;
      background-color: #fff;
      height: 74px;
      padding-top:16px ;

      .btn {
        margin-bottom: 16px;
        width: 327px;
        height: 42px;
        background: rgba(255, 102, 68, 1);
        border-radius: 21px;
        margin-left: 24px;
        line-height: 42px;
        text-align: center;
        color: #fff;
      }
    }


    .empty-post {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 92px;
      > img {
        margin-left: 9px;
        margin-bottom: 14px;
        width: 59px;
        height: 48px;
      }

      .success-text {
        font-size:16px;
        font-weight:500;
        color:rgba(64,64,64,1);
        margin-bottom: 12px;
      }
      .matching-text{
        font-size:14px;
        font-weight:400;
        color:rgba(156,156,156,1);
        margin-bottom: 52px;
      }
      .empty-btn {
        width: 176px;
        height: 42px;
        background: rgba(255, 102, 68, 1);
        border-radius: 21px;
        line-height: 42px;
        text-align: center;
        color: #FFFFFF;
        font-weight: 400;
        font-size: 16px;
      }
    }
  }
</style>